import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { UseFormRegisterReturn } from 'react-hook-form';  
import { getIOSInputEventHandlers } from 'view/hooks';
import { Palette } from 'core/config';
import { Data, noop } from 'core/utilities';

interface Props 
{
    type?          : string;
    name           : string;
    label?         : string;
    placeholder?   : string;
    initialValue?  : string;
    input          : UseFormRegisterReturn;
    setValue?      : (name : string, value : any) => void;
    setFormErrors? : React.Dispatch<React.SetStateAction<Data>>;
    normalizer?    : (e : React.ChangeEvent<HTMLInputElement>) => void;
    validator?     : (value : string) => string;
}

export const IncomeInput : React.FunctionComponent<Props> = ({ 
    type,
    name,
    label, 
    placeholder,
    initialValue,
    input,
    children,
    setValue,
    setFormErrors,
    normalizer=noop,
    validator=()=>''
}) => 
{
    const [ hasBlurred, setHasBlurred ] = useState<boolean>(false);
    const [ error, setError ] = useState<string>('');

    useEffect(() => 
    {
        if (initialValue) setValue && setValue(name, initialValue);
    }, []);

    const onChange = (e : React.ChangeEvent<HTMLInputElement>) =>
    {
        normalizer(e);
        const error = validator(e.target.value);
        setError(error);
        setFormErrors && setFormErrors(errors => ({ ...errors, [name]: error }));
        setValue && setValue(name, e.target.value);
    };

    return (
        <Container>
            <Label>{label}</Label>
            <Input
                type={type ?? 'text'}
                placeholder={placeholder} 
                {...input}
                {...getIOSInputEventHandlers()}
                onChange={onChange}
                onBlur={() => setHasBlurred(true)}
            />
            {hasBlurred && Boolean(error) && <CustomFormHelperText>
                {error}
            </CustomFormHelperText>}
            {children}
        </Container>
    );
};

const Container = styled.div`
    margin-left: 60px;
    margin-right: 60px;
`;

const Input = styled.input`
    background-color: ${Palette.EGGSHELL_WHITE};
    border-radius: 11px;
    border: none;
    height: 37px;
    width: 254px;
    padding-left: 15px;
    padding-right: 30px;
    color: ${Palette.BLUE};
    font-size: 12px;
    font-family: 'SofiaPro-Regular';

    @media only screen and (min-width: 1300px) {
        font-size: 12px;
    }

    @media only screen and (min-width: 1900px) {
        font-size: 14px;
    }
    
    :focus {
        outline: none;
    }

    ::placeholder {
        opacity: 0.2;
    }
`;

const Label = styled.div`
    margin-top: 20px;
    margin-bottom: 5px;
    color: ${Palette.BLUE };
    font-size: 10px;
    font-family: 'SofiaPro-Regular';

    @media only screen and (min-width: 1300px) {
        font-size: 12px;
    }

    @media only screen and (min-width: 1900px) {
        font-size: 14px;
    }
`;

const CustomFormHelperText = styled.p`
        font-family: 'SofiaPro-Regular';
        color: red;
        font-size: 10px;

        @media only screen and (min-width: 1300px) {
            font-size: 12px;
        }

        @media only screen and (min-width: 1900px) {
            font-size: 14px;
        }
`;